<template>
  <div class="marketing-automation-list">
    <v-data-table class="marketing-automation-list-table"
                  :headers="headers"
                  :items="automationList"
                  :loading="loading"
                  :hide-actions="true"
                  :no-data-text="$t('message.generics.message.noResultsFound')"
                  :no-results-text="$t('message.generics.message.noResultsFound')"
                  disable-initial-sort>

      <template slot="items"
                slot-scope="props">
        <marketing-automation-list-item :item="props.item"
                                        @duplicated="reloadList"
                                        @deleted="reloadList"
                                        @edited="reloadList" />
      </template>
    </v-data-table>

    <infinite-loading :identifier="infiniteId"
                      @infinite="fetchList">
      <div slot="no-results"></div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import MarketingAutomationListItem from "@components/modules/marketing/automation/list/item/MarketingAutomationListItem";
import EventBus from "@packages/event-bus";
import InfiniteLoading from "vue-infinite-loading";

export default {
  components: {
    MarketingAutomationListItem,
    InfiniteLoading,
  },
  data() {
    return {
      loading: false,
      automationList: [],
      infiniteId: +new Date(),
      filter: {
        page: 0,
        filter: "",
      },
    };
  },
  props: {},

  computed: {
      headers() {
          return [
              { text: this.$t('message.generics.message.status'), value: "", sortable: false },
              { text: this.$t('message.generics.message.name'), value: "", sortable: false },
              { text: this.$t('message.generics.message.creationDate'), value: "", sortable: true },
              { text: this.$t('message.automation.message.lastEdit'), value: "", sortable: true },
              { text: this.$t('message.marketingGenerics.message.actions'), value: "", sortable: false },
          ]
      }
  },

  created() {
    EventBus.$on("AUTOMATION_SEARCH", this.searchList);
  },
  beforeDestroy() {
    EventBus.$off("AUTOMATION_SEARCH", this.searchList);
  },
  methods: {
    reloadListAndTotal() {
      this.reloadList();
    },
    async searchList(search) {
      this.filter.filter = search;
      this.reloadList();
    },
    async reloadList() {
      this.filter.page = 0;
      this.automationList = [];

      this.infiniteId++;
    },
    async fetchList($state) {
      this.loading = true;

      const automationList = await this.$api.marketing.automation.flow.list({
        page: this.filter.page,
        filter: this.filter.filter,
        isAutomation: this.filter.isAutomation,
      });

      if (automationList.length) {
        this.filter.page += 1;

        this.automationList.push(...automationList);

        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-list {
  .marketing-automation-list-table {
    ::v-deep .v-table__overflow {
      padding-bottom: 100px;
    }
  }
}
</style>
